var t=function(t){return t.Create="Create",t.Update="Update",t.Delete="Delete",t.StatusChange="StatusChange",t.Export="Export",t}({});export{t as AuditEntityEventType};
//# sourceMappingURL=types.js.map